import { promisifiedDOMListener } from '~/utils/async/promisifiedDOMListener';

/**
 * * Asynchronous Navigation
 *
 * @description
 * This function navigates to a new URL asynchronously.
 */
export const asyncNavigation = async (url: string, $window: Window = globalThis.window as Window) => {
  $window.location.href = url;

  await promisifiedDOMListener('beforeunload');
};
